"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var dom_1 = require("../../runtime/dom");
var awsui_select_dropdown_1 = require("../dropdown/awsui-select-dropdown");
var awsui_input_1 = require("../input/awsui-input");
var SelectWrapper = /** @class */ (function (_super) {
    __extends(SelectWrapper, _super);
    function SelectWrapper() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SelectWrapper.prototype.findTrigger = function () {
        return this.find('.awsui-select-trigger');
    };
    SelectWrapper.prototype.findDropdown = function () {
        return this.findComponent('awsui-select-dropdown', awsui_select_dropdown_1.default);
    };
    /**
     * Returns the input that is used for filtering. Returns `null` if `enableFiltering` is not set to `true`.
     */
    SelectWrapper.prototype.findFilteringInput = function () {
        return this.findComponent('awsui-select-filter awsui-input', awsui_input_1.default);
    };
    SelectWrapper.prototype.findPlaceholder = function () {
        return this.find('.awsui-select-trigger-placeholder');
    };
    SelectWrapper.prototype.findStatusIndicator = function () {
        var dropdown = this.findDropdown();
        return dropdown && dropdown.find('[awsui-select-dropdown-region="listBottom"]');
    };
    SelectWrapper.prototype.findErrorRecoveryButton = function () {
        var statusIndicator = this.findStatusIndicator();
        return statusIndicator && statusIndicator.find('.awsui-dropdown-recovery-button');
    };
    SelectWrapper.prototype.openDropdown = function () {
        this.findTrigger().fireEvent(new dom_1.MouseEvent('mousedown'));
        this.findTrigger().fireEvent(new dom_1.MouseEvent('mouseup'));
    };
    SelectWrapper.prototype.closeDropdown = function () {
        document.body.dispatchEvent(new dom_1.MouseEvent('mousedown'));
    };
    /**
     * Selects an option for the given index by triggering a MouseEvent.
     *
     * When using grouped options, use `selectOptionById` instead.
     *
     * This utility does not open the dropdown of the given select and it will need to be called explicitly in your test.
     * On selection the dropdown will close automatically.
     *
     * Example:
     * ```
     * wrapper.openDropdown();
     * wrapper.selectOption(0);
     * ```
     *
     * @param index 1-based index of the option to select
     */
    SelectWrapper.prototype.selectOption = function (index) {
        var option = this.findDropdown().findOption(index);
        option.fireEvent(new dom_1.MouseEvent('mouseup'));
    };
    /**
     * Selects an option for the given id by triggering a MouseEvent.
     *
     * This utility does not open the dropdown of the given select and it will need to be called explicitly in your test.
     * On selection the dropdown will close automatically.
     *
     * Example:
     * ```
     * wrapper.openDropdown();
     * wrapper.selectOptionById('0');
     * ```
     *
     * @param id
     */
    SelectWrapper.prototype.selectOptionById = function (id) {
        var option = this.findDropdown().findOptionById(id);
        option.fireEvent(new dom_1.MouseEvent('mouseup'));
    };
    __decorate([
        dom_1.usesDom
    ], SelectWrapper.prototype, "openDropdown", null);
    __decorate([
        dom_1.usesDom
    ], SelectWrapper.prototype, "closeDropdown", null);
    __decorate([
        dom_1.usesDom
    ], SelectWrapper.prototype, "selectOption", null);
    __decorate([
        dom_1.usesDom
    ], SelectWrapper.prototype, "selectOptionById", null);
    return SelectWrapper;
}(dom_1.ComponentWrapper));
exports.default = SelectWrapper;
//# sourceMappingURL=awsui-select.js.map